export default __webpack_public_path__ + "static/B0041-9f0836a962eb0ce083922b9672bcdbc4.png";